// @ts-strict-ignore
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Redirect, useLocation } from 'react-router';

import { LoadingPage } from 'pages/LoadingPage';
import { NotFoundPage } from 'pages/NotFoundPage';
import { State } from 'store/main';
import { fetchPage } from 'store/main/ducks/contents';
import { useMainDispatch } from 'store/main/hooks/useMainDispatch';
import { useAmpContext } from 'utils/AmpContext';
import { hasParam } from 'utils/url';

import { AmpContentPage } from './AmpContentPage';
import { ContentPage } from './ContentPage';
import { ContentPageLayout } from './ContentPageLayout';

type Props = {
  slug: string;
  amp: boolean;
};

export default function ContentPageContainer({ slug, amp }: Props) {
  const dispatch = useMainDispatch();
  const location = useLocation<{ subsite?: string }>();
  const requestIsAmp = useAmpContext();

  const { contents, mainSearch } = useSelector((state: State) => ({
    contents: state.contents,
    mainSearch: state.mainSearch,
  }));

  // @ts-expect-error fix me
  const { isLandingPage } = mainSearch || false;
  const contentObj = contents.byUrl[slug] || {};

  // @ts-expect-error fix me
  const { content } = contentObj;
  // @ts-expect-error fix me
  const pageState = contentObj.state || 'UNFETCHED';

  const hasHomePage = content && content.subsite && !!content.subsite.homePage;
  const heroSearch = content && content.heroSearch;

  const onlySearchResults = heroSearch && heroSearch.onlyResults;
  const onlyArticleResults =
    content && content.onlySearchResults && hasHomePage;

  useEffect(() => {
    if (!amp) {
      dispatch(fetchPage(slug));
    }
  }, [slug, amp, dispatch]);

  if (hasParam(location.search, 'saved')) {
    return (
      <Redirect
        to={`${location.pathname}${
          location.search ? `${location.search}&` : '?'
        }`}
      />
    );
  }

  if (
    onlySearchResults ||
    isLandingPage ||
    (onlyArticleResults && hasHomePage)
  ) {
    let qs = '?q=';
    if (location.search && location.search.includes('?q=')) {
      qs = location.search;
    } else if (location.search) {
      qs = `${location.search}&q=`;
    }

    return <Redirect to={`${location.pathname}${qs}`} />;
  }

  if (['FETCHING', 'UNFETCHED'].includes(pageState)) {
    if (amp) {
      // It's an AMP URL, but content is not already available.
      // Meaning it's disabled for that page.
      return <NotFoundPage />;
    }

    return <LoadingPage />;
  }

  // @ts-expect-error fix me
  if (content && contentObj.type === 'CMS_PAGE') {
    return (
      <ContentPageLayout content={content}>
        {requestIsAmp ? (
          <AmpContentPage content={content} searchMode={false} />
        ) : (
          <ContentPage content={content} />
        )}
      </ContentPageLayout>
    );
  }

  return <NotFoundPage />;
}
